export const HEIGHT_MODIFIER_FOR_16_9_RATIO = 0.5625
